import * as React from 'react';

import './errors.css';

interface IProps {
    errors: Array<string>
}

export const Errors = (props: IProps) => {
    return (
        <div className="errors">
            <ul className="errors__list">
                {props.errors.map((error, index) => {
                    return (
                        <li className="errors__list__item" key={index}>{error}</li>
                    );
                })}
            </ul>
        </div>

    );
};



// WEBPACK FOOTER //
// ./src/SharedComponents/Errors/Errors.tsx